import { render, staticRenderFns } from "./BetweenArticle.vue?vue&type=template&id=3a6b090a&scoped=true&"
import script from "./BetweenArticle.vue?vue&type=script&lang=js&"
export * from "./BetweenArticle.vue?vue&type=script&lang=js&"
import style0 from "./BetweenArticle.vue?vue&type=style&index=0&id=3a6b090a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b090a",
  null
  
)

export default component.exports